import React from 'react';

export interface TableContext {
  renderBorderBetweenRows: boolean;
}

export const TableContext = React.createContext<TableContext>(undefined!);

type Props = {
  renderBorderBetweenRows: boolean;
  children: React.ReactNode;
};

const TableState = (props: Props) => {
  return (
    <TableContext.Provider
      value={{
        renderBorderBetweenRows: props.renderBorderBetweenRows,
      }}
    >
      {props.children}
    </TableContext.Provider>
  );
};

export { TableState };
